/**
* Home Featured Events JS
* -----------------------------------------------------------------------------
*
* All the JS for the Home Featured Events component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'home-featured-events',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.home-featured-events' ).each( function( key, component ) {
        const splide = new Splide( $( component ).find( '.splide--home-featured-events' )[0], {
          pagination: false,
          arrows: true,
          gap: '24px',
          perPage: 2,
          perMove: 1,
          speed: 750,
          breakpoints: {
            1024: {
              perPage: 2,
            },
            768: {
              perPage: 1,
            },
          },
        } );

        splide.mount();
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'home-featured-events', COMPONENT );
} )( app );
